// The Comic Machine - Canvas UI

var CanvasController = (function() {

  // Handles UI and DOM manipulation
  var UI = {

    isClickingLayer: false,
    isClickingHandle: false,
    clickedHandleSize: null,
    clickedHandlePosition: null,

    // DOM elements to manage
    elements: {
      container: null
    },

    // Initialize the UI and DOM manager
    initialize: function() {

      // Set base container
      UI.elements.container = document.querySelector(".stage") || document;

      // Set the width and height, including the Canvas.base padding offset
      Canvas.stage.width = Canvas.size.width + (Canvas.size.offset * 2);
      Canvas.stage.height = Canvas.size.height + (Canvas.size.offset * 2);

      // Create the base canvas element and draw the canvas
      Canvas.base = new Canvas({
        name: "base",
        width: Canvas.stage.width,
        height: Canvas.stage.height
      });
      Canvas.base.element.id = "canvas";

      // Draw the base canvas layer
      Canvas.drawCanvas();

      // Append the canvas element to its container in the DOM
      UI.elements.container.appendChild(Canvas.base.element);

      // Set the initial scale and size
      UI.scaleCanvas();
      // UI.resizeCanvas();
      UI.centerCanvas();

      // Bind handlers to events
      UI.bindEvents();

    },

    // Bind handlers to events
    bindEvents: function() {

      // Method to prevent default functionality
      function preventDefault(event) {
        event.stopPropagation();
        event.preventDefault();
      }

      // Handle mouse events over canvas
      Canvas.base.element.addEventListener("mousedown", UI.onMouseDown, false);
      Canvas.base.element.addEventListener("mousemove", UI.onMouseMove, false);
      Canvas.base.element.addEventListener("mouseup", UI.onMouseUp, false);
      Canvas.base.element.addEventListener("mousecancel", UI.onMouseUp, false);

      // TODO: Handle file upload from drag and drop
      // Canvas.base.element.addEventListener("dragenter", preventDefault, true);
      // Canvas.base.element.addEventListener("dragover", preventDefault, true);
      // Canvas.base.element.addEventListener("drop", function(event) {
      //    preventDefault(event);
      //    var file = event.dataTransfer.files[0];
      //    var name = Canvas.readFile(file, function(src, name) {
      //       Canvas.loadImage(src, name, function(image, name) {
      //          Canvas.drawImageLayer(image, name, null, file);
      //       });
      //    });
      // }, true);

      // Handle canvas on zoom / scale
      var zoomButtons = document.queryAll(".zoom a");
      zoomButtons.forEach(function(button, i) {
        // Add handlers to zoom buttons
        button.onclick = UI.scaleCanvas;
      });

      // Handle canvas on window resize
      // window.addEventListener("resize", UI.resizeCanvas, false);

    },

    // On mouse down on canvas
    onMouseDown: function(event) {

      var layer = Comic.currentPage().currentLayer();

      if (layer.text && layer.text.editing) {
        return;
      }

      var move = Mouse.down(event);

      if (!move) {
        return;
      }

      // var initial = move.initialPosition;
      // var current = move.currentPosition;

      // Check layer handles for touch down
      var handleClicked = UI.checkHandles(event, true);

      if (layer) {
        var transition = layer.transition[layer.preview];
      }

      // Set the active layer based on click
      // var clickedIndex = UI.getCurrentLayer(current);
      // var currentPage = Comic.currentPage();
      // var isChanging = clickedIndex !== currentPage.layerIndex;
      // var isBase = clickedIndex === 0;

      // if (isChanging && !isBase && !handleClicked) {
      //    currentPage.layerIndex = clickedIndex;
      //    Events.global.emit("tcm.layer.update");
      // }

      // if(currentPage.layerIndex === clickedIndex && !isBase) {
      //    UI.isClickingLayer = true;
      // }

    },

    // On mouse move on canvas
    onMouseMove: function(event) {

      var move = Mouse.move(event);

      if (!move) {
        return;
      }

      var current = move.currentPosition;
      var offset = move.offsetPosition;
      var page = null;
      var layer = null;

      // Check layer handles for touch down
      var handleClicked = UI.checkHandles(event);

      // If a handle is being clicked
      if (UI.isClickingHandle !== false) {

        var type = UI.isClickingHandle.type;
        var width = UI.clickedHandleSize.width;
        var height = UI.clickedHandleSize.height;
        var shift = event.shiftKey;

        layer = UI.isClickingHandle.layer;
        page = layer.page;

        if (layer.transition[layer.preview].set === true) {
          return
        }

        if (type === "scale-topleft" || type === "scale-topright") {
          height -= offset.y;
          layer.offset.y = UI.clickedHandlePosition.y + offset.y;
        } else {
          height += offset.y;
        }

        if (type === "scale-topleft" || type === "scale-bottomleft") {
          width -= offset.x;
          layer.offset.x = UI.clickedHandlePosition.x + offset.x;
        } else {
          width += offset.x;
        }

        if (shift || layer.proportionLock) {
          height = Math.floor(layer.content.height * (width / layer.content.width));
        }

        layer.setSize(width, height);
        layer.canvas.drawImage(layer.content, null, {
          x: width,
          y: height
        });

      } else {

        page = Comic.currentPage();

        // Set the active layer offset based on mouse move
        if (page.layerIndex > 0) {
          layer = Comic.currentLayer();
          if (layer.transition[layer.preview].set === true) {
            return
          }
          layer.setOffset(offset);
        }

      }

      if (layer !== null) {

        var transition = layer.transition[layer.preview];

        var position = {
          x: layer.position.x + layer.offset.x,
          y: layer.position.y + layer.offset.y
        };
        layer.transition[layer.preview].x = position.x;
        layer.transition[layer.preview].y = position.y;
        layer.transition[layer.preview].width = layer.size.width;
        layer.transition[layer.preview].height = layer.size.height;
        page.renderPage();
      }

    },

    // On mouse up on canvas
    onMouseUp: function(event) {

      var move = Mouse.up(event);

      if (!move) {
        return;
      }

      var page = Comic.currentPage();
      var layer = Comic.currentLayer();

      // Check layer handles for touch down
      if (UI.checkHandles(event)) {
        layer = UI.isClickingHandle.layer;
        // Reset isScaling flag
        if (layer) {
          var transition = layer.transition[layer.preview];
          if (transition.set === false) {
            layer.isScaling = false;
            var type = UI.isClickingHandle.type;
            if (type === "scale-topleft" || type === "scale-topright") {
              layer.position.y += layer.offset.y;
            }
            if (type === "scale-topleft" || type === "scale-bottomleft") {
              layer.position.x += layer.offset.x;
            }
            layer.setOffset({
              x: 0,
              y: 0
            });
            Comic.renderPage();
          }
        }
      } else {
        // Set final position of layer on mouse up
        if (page.layerIndex > 0) {
          var transition = layer.transition[layer.preview];
          if (transition.set === false) {
            layer.setPosition({
              x: transition.x,
              y: transition.y
            });
            layer.setOffset({
              x: 0,
              y: 0
            });
            if (transition) {
              if (transition.x || transition.x === 0) layer.position.x = transition.x;
              if (transition.y || transition.y === 0) layer.position.y = transition.y;
              if (transition.width || transition.width === 0) layer.size.width = transition.width;
              if (transition.height || transition.height === 0) layer.size.height = transition.height;
              layer.setSize(layer.size.width, layer.size.height, true);
            }
          }
        }
      }

      // Reset handle references
      UI.isClickingLayer = false;
      UI.isClickingHandle = false;
      UI.clickedHandleSize = null;

    },

    // Method to check the pixel alpha value of each layer on click
    getCurrentLayer: function(position) {

      var canvas = new Canvas();
      var scale = Canvas.base.scale;
      var page = Page.currentPage();
      var current = 0; //page.layerIndex;
      var currentLayer = Page.currentLayer();

      Comic.currentPage().pageLayers.forEach(function(layer, i) {
        var offset = {
          x: layer.size.width,
          y: layer.size.height
        };
        canvas.setSize(canvas.element.width, canvas.element.height, scale);
        canvas.setScale(scale);
        canvas.drawImage(layer.canvas.element, layer.position, offset);
        current = canvas.getPixelAlpha(position) > 0 ? i : current;
      });

      return current;

    },

    // Method to check layer handles for clicks
    checkHandles: function(event, isClicking) {

      isClicking = isClicking || false;

      var currentHandle = null;
      var handles = Canvas.base.handles;
      var offset = Canvas.size.offset;
      var position = {
        x: event.pageX - Mouse.getOffset().left,
        y: event.pageY - Mouse.getOffset().top
      };

      handles.forEach(function(handle, i) {
        if (currentHandle === null &&
          position.x < handle.right - offset &&
          position.x > handle.left - offset &&
          position.y > handle.top - offset &&
          position.y < handle.bottom - offset) {
          currentHandle = handle;
        }
      });

      if (currentHandle !== null) {
        if (isClicking && currentHandle.layer) {
          UI.isClickingHandle = currentHandle;
          currentHandle.layer.isScaling = true;
          UI.clickedHandleSize = JSON.parse(JSON.stringify(currentHandle.layer.size));
          UI.clickedHandlePosition = JSON.parse(JSON.stringify(currentHandle.layer.offset));
        }
      }

      Canvas.base.element.setAttribute("data-style", currentHandle ? currentHandle.type : "none");

      // Set the appropriate cursor based on mouse position
      // if (mouse.currentHandle === null) {
      //    canvas.style.cursor = mouse.getCursor(currentHandle);
      // }

      return currentHandle !== null;

    },

    // Method to handle canvas on window resize
    resizeCanvas: function() {

      // Get the ratio of the current size offset
      //var ratio = Canvas.base.element.offsetWidth / Canvas.size.width;

      // Adjust the height based on the width to maintain aspect ratio
      //Canvas.base.element.width  = UI.elements.container.offsetWidth;
      //Canvas.base.element.height = UI.elements.container.offsetHeight;
      //Canvas.base.element.style.width = Canvas.base.element.offsetWidth + "px";
      //Canvas.base.element.style.height = (Canvas.size.height * ratio) + "px";

      // Scale the canvas
      //Canvas.base.context.scale(ratio, ratio);

      // Render the current page of the comic
      //Comic.current && Comic.renderPage();

    },

    // Method to handle canvas scale / zoom
    scaleCanvas: function(event) {

      // Set default scale multiplyer
      var scale = 0;
      // Get the base canvas element
      var canvas = Canvas.base.element;

      // If being fired from click event
      if (event && event.preventDefault) {
        // Prevent default click functionality
        event.preventDefault();
        // Get the scale from the element
        scale = window.parseFloat(this.getAttribute("data-zoom"));
      }

      // Handle zooming below 100% and above 500%
      var scaleOver = scale * 10;
      var scaleUnder = Canvas.base.scale > 1 ? scale * 5 : scale;
      scale = Canvas.base.scale > 5 ? scaleOver : scaleUnder;

      // Clamp and round the new scale amount
      Canvas.base.scale = Math.clamp(Canvas.base.scale + scale, 0.1, 10);
      Canvas.base.scale = Math.decimalRound(Canvas.base.scale, 1);

      // Resize the canvas
      canvas.width = Canvas.stage.width * Canvas.base.scale;
      canvas.height = Canvas.stage.height * Canvas.base.scale;

      // Position the canvas centered on the stage
      var marginTop = canvas.height / 2;
      var marginLeft = canvas.width / 2;
      var offsetHeight = UI.elements.container.offsetHeight;
      var offsetWidth = UI.elements.container.offsetWidth;
      marginTop = canvas.height > offsetHeight ? offsetHeight / 2 : marginTop;
      marginLeft = canvas.width > offsetWidth ? offsetWidth / 2 : marginLeft;
      canvas.style.marginLeft = -marginLeft + "px";
      canvas.style.marginTop = -marginTop + "px";

      // Scale the canvas
      Canvas.base.context.scale(Canvas.base.scale, Canvas.base.scale);

      // Render the current page of the comic
      Comic.current && Comic.renderPage();

      // Log the result
      // console.log("scale", Canvas.base.scale);

    },

    // Method to handle centering the canvas
    centerCanvas: function() {

      var container = UI.elements.container;
      var scrollWidth = container.scrollWidth;
      var scrollHeight = container.scrollHeight;
      var offsetWidth = container.offsetWidth;
      var offsetHeight = container.offsetHeight;

      if (scrollWidth > offsetWidth) {
        container.scrollLeft = (scrollWidth - offsetWidth) / 2;
      }
      if (scrollHeight > offsetHeight) {
        container.scrollTop = (scrollHeight - offsetHeight) / 2;
      }

    },

  };

  // Wait for the comic to initialize before initializing the UI manager
  Events.global.on("tcm.initialized", UI.initialize);

  // Public / exposed object
  return UI;

})();
